import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.border = this.el.querySelector('.o-subnav_border');
        this.mask = this.el.querySelector('.o-subnav_mask');

        this.events = {
            click: {
                close: 'close'
            }
        }

        this.el.querySelectorAll('.o-subnav_tabs_tab').forEach(tab => {
            tab.addEventListener('mouseenter', (e) => {
                this.activateTab(e);
            });
        });
    }

    open(id) {
        if (this.el.querySelector('.o-subnav_item.-opened')) {
            if (this.el.querySelector('.o-subnav_item.-opened').getAttribute('data-menu') == id) {
                this.close();
                return;
            } else {
                this.el.querySelector('.o-subnav_item.-opened').classList.remove('-opened');
                setTimeout(() => {
                    this.el.querySelector('.o-subnav_item[data-menu="' + id + '"]').classList.add('-opened');
                }, 400);
            }
        } else {
            this.el.classList.add('-opened');
            this.el.querySelector('.o-subnav_item[data-menu="' + id + '"]').classList.add('-opened');
            this.call('stop', 'Scroll');
        }
    }

    close() {
        if (this.el.querySelector('.o-subnav_item.-opened')) {
            this.el.classList.remove('-opened');
            this.el.querySelector('.o-subnav_item.-opened').classList.remove('-opened');
        }

        if (document.querySelector('.o-navbar .mainMenu .-active')) {
            document.querySelector('.o-navbar .mainMenu .-active').classList.remove('-active');
        }
        if (document.querySelector('.o-navbar .mobileMenu .-active')) {
            document.querySelector('.o-navbar .mobileMenu .-active').classList.remove('-active');
        }

        this.call('start', 'Scroll');
    }

    activateTab(e) {
        let parent = e.currentTarget.closest('.o-subnav_item');
        let tabId = e.currentTarget.getAttribute('data-tab');

        parent.querySelector('.o-subnav_tabs_tab.-active').classList.remove('-active');
        parent.querySelector('.o-subnav_tabs_tab[data-tab="' + tabId + '"]').classList.add('-active');

        parent.querySelector('.o-subnav_tabs_content.-active').classList.remove('-active');
        parent.querySelector('.o-subnav_tabs_content[data-tab="' + tabId + '"]').classList.add('-active');
    }
}
